import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
import { DefaultButton, FontIcon, Stack, Image, Text, mergeStyleSets, ImageFit } from '@fluentui/react';
import { numberToLocaleString, timeToLocalLocaleString, timeToLocalString } from '@shared/utils/localeUtils';
import { NeutralColors } from '@fluentui/theme';
const contentStyles = mergeStyleSets({
    upcomingEvent: {
        width: 512,
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: NeutralColors.gray30,
        padding: 16,
        display: 'flex',
        flexDirection: 'column'
    },
    upcomingEventLogo: {
        width: 60,
        height: 60,
        position: 'relative',
        overflow: 'hidden'
    },
    upcomingEventLargeIcon: {
        width: 60,
        height: 60,
        position: 'relative',
        overflow: 'hidden',
        color: '#69AFE5'
    },
    upcomingEventLargeIconImg: {
        width: '100%',
        height: '100%'
    },
    upcomingEventNameText: {
        marginTop: 8,
        fontSize: 18,
        lineHeight: 24,
        fontWeight: 600,
        color: NeutralColors.gray160
    },
    upcomingEventDefaultIcon: {
        fontSize: 40,
        width: 40,
        height: 50,
        color: '#69AFE5'
    },
    upcomingEventDefaultPanel: {
        padding: 10,
        width: 60,
        height: 60,
        backgroundColor: '#EFF6FC'
    },
    upcomingEventNormalText: {
        marginTop: 8,
        fontSize: 12,
        lineHeight: 16,
        fontWeight: 600,
        color: NeutralColors.gray130
    },
    upcomingEventLinkButton: {
        width: 212,
        marginTop: 24,
        fontSize: 14,
        lineHeight: 20,
        fontWeight: 600,
        color: NeutralColors.gray190
    },
    externallinkIcon: {
        marginLeft: 8,
        height: 24,
        fontSize: 14,
        color: NeutralColors.gray190
    }
});
export const LinkedinUpcomingEvent = ({ event, locale, countryCode, onExternalLinkClick }, context)=>{
    const { startTime, endTime, name, logoUrl, eventType, attendeeCount, detailsUrl } = event;
    const startTimeStr = timeToLocalString({
        timeUTCSeconds: startTime / 1000,
        locale,
        countryCode
    });
    const endTimeStr = timeToLocalLocaleString({
        timeUTCSeconds: endTime / 1000,
        locale,
        countryCode
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: contentStyles.upcomingEvent,
        children: [
            logoUrl ? /*#__PURE__*/ _jsx("div", {
                className: contentStyles.upcomingEventLogo,
                children: /*#__PURE__*/ _jsx("div", {
                    className: contentStyles.upcomingEventLargeIcon,
                    children: /*#__PURE__*/ _jsx(Image, {
                        imageFit: ImageFit.contain,
                        className: contentStyles.upcomingEventLargeIconImg,
                        src: logoUrl
                    })
                })
            }) : /*#__PURE__*/ _jsx("div", {
                className: contentStyles.upcomingEventDefaultPanel,
                children: /*#__PURE__*/ _jsx(FontIcon, {
                    "aria-label": "Calendar",
                    iconName: "Calendar",
                    className: contentStyles.upcomingEventDefaultIcon
                })
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: contentStyles.upcomingEventNameText,
                children: name
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: contentStyles.upcomingEventNormalText,
                children: eventType
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: contentStyles.upcomingEventNormalText,
                children: context.locParams('Linkedin_Event_Time', [
                    startTimeStr,
                    endTimeStr
                ])
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: contentStyles.upcomingEventNormalText,
                children: context.locParams('Linkedin_Attendees_Count', [
                    numberToLocaleString({
                        number: attendeeCount,
                        locale,
                        countryCode
                    })
                ])
            }),
            /*#__PURE__*/ _jsx(DefaultButton, {
                className: contentStyles.upcomingEventLinkButton,
                href: detailsUrl,
                target: "_blank",
                onClick: onExternalLinkClick,
                children: /*#__PURE__*/ _jsxs(Stack, {
                    horizontal: true,
                    children: [
                        context.loc('Linkedin_Event_Link', 'View event on LinkedIn'),
                        /*#__PURE__*/ _jsx(FontIcon, {
                            iconName: "OpenInNewWindow",
                            className: contentStyles.externallinkIcon
                        })
                    ]
                })
            })
        ]
    });
};
LinkedinUpcomingEvent.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
